
export const meta = (meta) => {}
  
export const extraJS = null
  
//@import url('https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css?ver=5.7.2');

export const externalCSS = [
  { type:'webfont', href:"https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap" }
]
  